import React from "react";
import { FooterContainer } from "./style";
import { Col, Container, Row } from "react-bootstrap";

const Footer = () => {
  return (
    <FooterContainer>
      <Container>
        <Row>
          <Col sm={12} md={6}>
            <section className="footer-contact">
              <h6>ارتباط با ما</h6>
              <div className="text">
                تلفن تماس : 48491000-021
                <br />
                فکس : 46116519 – 021
                <br />
                ایمیل : info@arian-motor.ir
                <br />
                آدرس : کیلومتر 9 جاده مخصوص کرج، خیابان نخ زرین، پلاک 23، شرکت
                آرین موتور
                <br />
                ساعات پاسخگویی از شنبه تا چهارشنبه از ساعت 8 الی 17 می باشد.
              </div>
            </section>
          </Col>
          <Col sm={12} md={6}>
            <section className="copyright">
              <div className="logo">
                <img
                  className="footer-logo"
                  src="/footer-logo.png"
                  alt="lamari"
                />
              </div>
              <div className="enamad">
                <a referrerPolicy='origin' target='_blank' rel="noreferrer" href='https://trustseal.enamad.ir/?id=498348&Code=eU0yuuJoB1x4A2rPuGzFghfsJiS64w20'>
                  <img referrerPolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=498348&Code=eU0yuuJoB1x4A2rPuGzFghfsJiS64w20'
                       alt='' code='eU0yuuJoB1x4A2rPuGzFghfsJiS64w20' />
                </a>
              </div>
            </section>
          </Col>
        </Row>
      </Container>
    </FooterContainer>
  );
};
export default Footer;
